<template>
  <div class="box" v-if="!is_rb && adminId != null && adminId != '' && adminId != undefined ">
    <span></span>
  </div>
</template>

<script>

  export default {
    name: "official",
    props: {
      is_rb: [Boolean, null],
      adminId: [Number, String, null]
    },
    data() {
      return {}
    }
  }
</script>

<style scoped>
  .box {
    width: 18px;
    height: 18px;
    position: relative;
    background-image: url('https://files.wondercv.com/rn/bbs/official.png');
    overflow: hidden;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .box span {
    width: 3px;
    height: 25px;
    position: absolute;
    background-color: #fff;
    top: -50%;
    animation: play 1.5s infinite;
    opacity: .5;
  }

  @keyframes play {
    from {
      transform: translate(0, 0) rotate(45deg)
    }

    to {
      transform: translate(25px, 18px) rotate(45deg)
    }
  }
</style>